import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { AuthResponse, BaseTokensResponse } from '../../../auth/store/models/auth-response.interface';
import { map } from 'rxjs/operators';
import { Response } from '../../../interfaces/response.interface';
import { User } from '../../../pages/users-management/store/models/user';
import { ApiUrlService } from '../../../services/api-url.service';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private _url = `${this._apiService.apiUrl}/access`;

  constructor(
    private _http: HttpClient,
    private _apiService: ApiUrlService,
  ) {}

  public login(username: string, password: string, otp_code: string): Observable<AuthResponse> {
    const url = `${this._url}/signin`;

    return this._http.post<{ data: AuthResponse }>(url, { username, password, otp_code })
      .pipe(
        map(response => response.data),
      ) as Observable<AuthResponse>;
  }

  public switchOrganization(id: string): Observable<BaseTokensResponse> {
    const url = `${this._url}/switch/${id}`;

    return this._http.post<Response<BaseTokensResponse>>(url, {})
      .pipe(
        map(response => response.data),
      );
  }

  public refreshToken(refresh_token: string): Observable<BaseTokensResponse> {
    const url = `${this._url}/refresh`;

    return this._http.put<Response<BaseTokensResponse>>(url, { refresh_token })
      .pipe(
        map(response => response.data),
      );
  }

  public changePassword(oldPassword: string, newPassword: string): Observable<any> {
    const url = `${this._url}/password`;

    return this._http.put<any>(url, { old_password: oldPassword, new_password: newPassword });
  }

  public getUserData(): Observable<User> {
    const url = `${this._url}/profile`;

    return this._http.get<Response<{ user: User, org_enable_otp: boolean }>>(url)
      .pipe(
        map((response) => {
          return {
            ...response.data.user,
            org_enable_otp: response.data.org_enable_otp,
          };
        }),
      )
  }
}
